import type { MailboxInfo } from 'owa-client-types';
import getCalendarFoldersOperation from 'owa-service/lib/operation/getCalendarFoldersOperation';
import { getJsonRequestHeader } from 'owa-service/lib/ServiceRequestUtils';
import { getMailboxRequestOptions } from 'owa-request-options-types';
import type { TraceErrorObject } from 'owa-trace';
import type GetCalendarFoldersResponse from 'owa-service/lib/contract/GetCalendarFoldersResponse';

export async function getCalendarFoldersService(
    mailboxInfo: MailboxInfo
): Promise<GetCalendarFoldersResponse> {
    const options = getMailboxRequestOptions(mailboxInfo);
    const response = await getCalendarFoldersOperation({ Header: getJsonRequestHeader() }, options);

    if (response == null || !response.WasSuccessful) {
        const errorMessage = `getCalendarFoldersOperation failed with Error code: ${
            response ? response.ErrorCode : 'null response'
        }`;
        const error: TraceErrorObject = new Error(errorMessage);
        if (response) {
            error.fetchErrorType = 'ServerFailure';
        } else {
            error.networkError = true;
        }

        return Promise.reject(error);
    }

    return response;
}
